// extracted by mini-css-extract-plugin
export var content = "Cookie-module--content--d557f";